


































import Vue from 'vue'

export default Vue.extend({
  props: ['configConstant', 'prefixes'],
  methods: {
    handleDelete() {
      this.$emit('delete')
    },
  },
})
